export default "__VITE_ASSET__33KoF9RF__"